import type { PriceId } from '@iheartjane/types';
import type { DeepReadonly } from 'ts-essentials';

// eslint-disable-next-line no-restricted-imports
import type {
  MenuProduct,
  PendingCartProduct,
  ReservationCartProduct,
  StoreSpecial,
} from '@jane/shared/models';
import { defaultWeightIdForMenuProduct } from '@jane/shared/util';

interface InitialPriceIdArgs {
  appliedWeightFilter?: PriceId | '';
  applyNswFix?: boolean;
  cartProduct?:
    DeepReadonly<PendingCartProduct> | DeepReadonly<ReservationCartProduct>;
  menuProduct: MenuProduct;
  showOnlyWeights?: string[] | null;
  sortedByPrice?: boolean;
  special?: StoreSpecial;
}
export function initialPriceIdForProduct({
  applyNswFix,
  menuProduct,
  cartProduct,
  showOnlyWeights,
  special,
  appliedWeightFilter,
  sortedByPrice,
}: InitialPriceIdArgs): PriceId {
  if (cartProduct) {
    return cartProduct.price_id;
  }

  return defaultWeightIdForMenuProduct({
    applyNswFix,
    menuProduct,
    showOnlyWeights,
    special,
    appliedWeightFilter,
    sortedByPrice,
  });
}
